import { featureFlags } from "$global-providers/feature-flags-provider/feature-flags";
import { useFeatureFlag } from "$global-providers/feature-flags-provider/provider";
import {
  type EpocusEncounter,
  RXDB_EPOCUS_ENCOUNTER_COLLECTION_NAME,
} from "$global-providers/rxdb-provider/collections/epocus-encounter";
import {
  type EpocusExam,
  RXDB_EPOCUS_EXAM_COLLECTION_NAME,
} from "$global-providers/rxdb-provider/collections/epocus-exam";
import { useRxData } from "rxdb-hooks";

export type EpocusEncounterWithExams = EpocusEncounter & {
  exams: EpocusExam[];
};

export const usePatientEpocusEncounters = (patientId: string) => {
  const [patientHistoryFlag] = useFeatureFlag(
    featureFlags.pocus.patientHistory,
  );

  const { result: encounters } = useRxData<EpocusEncounter>(
    RXDB_EPOCUS_ENCOUNTER_COLLECTION_NAME,
    patientHistoryFlag
      ? (collection) =>
          collection.find({
            selector: { elephantPatientId: { $eq: patientId } },
            sort: [{ date: "desc" }],
            limit: 20,
          })
      : undefined,
  );

  const encounterIds = encounters.map((e) => e.id);

  const { result: exams } = useRxData<EpocusExam>(
    RXDB_EPOCUS_EXAM_COLLECTION_NAME,
    patientHistoryFlag && encounterIds.length > 0
      ? (collection) =>
          collection.find({
            selector: { encounterId: { $in: encounterIds } },
          })
      : undefined,
  );

  const encountersWithExams: EpocusEncounterWithExams[] = encounters.map(
    (encounter) => ({
      ...encounter,
      exams: exams.filter((exam) => exam.encounterId === encounter.id),
    }),
  );

  return { encounters: encountersWithExams };
};
